<template>
  <div>
    <main class="main">

      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
            <li>下載App</li>
          </ul>
        </div>
      </div>

<!--ios上架後移除 start-->
<!-- <p style="font-size: 13px; margin-top: -10px;"></p> -->
<!--ios上架後移除 end-->

      <div class="bodyContent">
        <div class="downloadApp">
          <div class="container row">
            <div class="col">
              <strong><img src="@/assets/images/logo_text.png" alt="一刻鯨選"></strong>
              <div class="qrcode"><img src="@/assets/images/global_qrcode.png" alt="下載QRcode"></div>
              <div class="stores">
                <a href="https://itunes.apple.com/tw/app/id1440248584?l=zh&mt=8" target="_blank"><img src="@/assets/images/appstore.png" title="從 App Store 下載"></a>
                <a href="https://play.google.com/store/apps/details?id=net.jinfm.app" target="_blank"><img src="@/assets/images/googleplay.png" title="從 Google Play 下載"></a>
              </div>
              <!--ios上架後移除 start-->
              <p style="font-size: 13px; margin-top: -10px;"></p>
              <!--ios上架後移除 end-->

              <!-- <div class="otherdown">
                  <a class="btnStyle_download" href="#"><span>下載 APK 檔</span></a>
              </div> -->
            </div>
            <div class="col">
              <figure class="wow fadeInUp">
                <img src="@/assets/images/deviceprev.png" alt="一刻鯨選裝置預覽圖">
              </figure>
            </div>
          </div>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'async',
  metaInfo () {
    return {

      title: '下載 App | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '下載 App | 一刻鯨選' },
        { property: 'og:site_name', content: '下載 App | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        // {property: 'og:image', content: '/static/logo.png'},
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

      ]
    }
  },

  data () {
    return {
      classData: []
    }
  },
  methods: {

    changePage (page) {
      this.$router.push({ path: '/' + page })
    }

  },
  mounted () {
    $('body').removeClass('index')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Download.vue